<template>
  <div>
    <div v-for="(item, key) in model" :key="key" class="cluster-row">
      <div class="cluster-field cluster-field--grow">
        <label class="cluster-label" :class="{ bold: !isAlternative }">
          {{ item.goal.name }}:
        </label>
        <div v-if="!isAlternative">
          {{ item.goal.description | empty }}
        </div>
        <div v-if="isReadOnly && isAlternative" class="cluster-value">
          {{ item.profession | empty }}
        </div>
        <validation-provider
          v-if="isAlternative && !isReadOnly"
          v-slot="{ errors }"
          class="cluster-input-wrap"
          :rules="professionRules(item)"
        >
          <custom-input
            v-model="item.profession"
            class="w-100"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
          />
        </validation-provider>
      </div>

      <div class="cluster-field">
        <label class="cluster-label">Porcentaje:</label>
        <div v-if="isReadOnly" class="cluster-value">
          {{ item.number | empty }}
        </div>
        <validation-provider
          v-else
          v-slot="{ errors, failedRules }"
          class="cluster-input-wrap cluster-input-wrap--number"
          :rules="numberRules(item)"
        >
          <custom-input
            v-model="item.number"
            class="w-100"
            :custom-error-msg="getErrorMessage(failedRules)"
            :error="errors[0]"
            min="0"
            placeholder="0-100"
            type="number"
          />
        </validation-provider>
      </div>

      <span
        v-if="!isReadOnly && aggregable && key !== 0"
        class="fas fa-times-circle text-danger cursor-pointer cluster-remove"
        @click="$emit('remove', key)"
      />
    </div>
    <div
      v-if="!isReadOnly && aggregable && canAdd"
      class="d-flex justify-content-end mt-3"
    >
      <action-button
        class="ml-2"
        i="fas fa-file-plus"
        variant="success"
        @click="$emit('add')"
      >
        Añadir
      </action-button>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';

export default {
  name: 'Clusters',
  components: {
    ValidationProvider,
    CustomInput,
    ActionButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    aggregable: {
      type: Boolean,
      default: false,
    },
    isAlternative: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  computed: {
    canAdd() {
      return this.max == null || this.model.length < this.max;
    },
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    getErrorMessage() {
      return (failedRules) => {
        if (!failedRules) return null;
        if (failedRules.required) return 'El campo es requerido.';
        if (failedRules.min_value) return 'El valor debe ser mayor a 0.';
        if (failedRules.max_value)
          return 'El valor debe ser menor o igual a 100.';
        return null;
      };
    },
  },
  methods: {
    rowHasValue(item) {
      const hasProfession = !!(
        item.profession && String(item.profession).trim()
      );
      const hasNumber =
        item.number !== null && item.number !== undefined && item.number !== '';
      return hasProfession || hasNumber;
    },
    professionRules(item) {
      if (!this.aggregable) return 'required';
      return this.rowHasValue(item) ? 'required' : '';
    },
    numberRules(item) {
      const base = 'min_value:0|max_value:100';
      if (!this.aggregable) return `required|${base}`;
      return this.rowHasValue(item) ? `required|${base}` : '';
    },
  },
};
</script>

<style scoped>
.cluster-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.5rem;
  background: #f2f2f2;
  border-radius: 6px;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
}

.cluster-field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.cluster-field--grow {
  flex: 1 1 280px;
  min-width: 240px;
}

.cluster-label {
  margin-bottom: 0;
  white-space: nowrap;
  font-weight: 500;
}

.cluster-value {
  min-height: 1.25rem;
}

.cluster-input-wrap {
  flex: 1 1 auto;
}

.cluster-input-wrap--number {
  flex: 0 0 110px;
  width: 110px;
}

.cluster-remove {
  margin-left: 0.25rem;
}
</style>
